import React from 'react';
import PropTypes from 'prop-types';

import InputGroup from '../InputGroup';
import StudyListTableRow from './StudyListTableRow';

const StudyListTable = ({
  tableDataSource,
  querying,
  filtersMeta,
  filterValues,
  onFilterChange,
  isSortingEnabled,
}) => {
  const totalGrid =
    (filtersMeta || []).reduce((sum, field) => sum + (field.gridCol || 0), 0) || 1;
  const { sortBy, sortDirection } = filterValues || {};

  return (
    <div className="study-list-table-shell bg-black">
      <table className="study-list-unified-table w-full border-collapse text-white">
        <colgroup>
          <col className="study-list-col-expand" />
          {(filtersMeta || []).map(field => (
            <col
              key={field.name}
              className={field.name === 'instances' ? 'study-list-col-instances' : undefined}
              style={
                field.name === 'instances'
                  ? undefined
                  : { width: `${((field.gridCol || 0) / totalGrid) * 100}%` }
              }
            />
          ))}
        </colgroup>
        {filtersMeta?.length ? (
          <thead className="study-list-thead">
            <InputGroup
              inputMeta={filtersMeta}
              values={filterValues}
              onValuesChange={onFilterChange}
              sorting={{ sortBy, sortDirection }}
              onSortingChange={sortingValues =>
                onFilterChange({
                  ...filterValues,
                  ...sortingValues,
                })
              }
              isSortingEnabled={Boolean(isSortingEnabled)}
            />
          </thead>
        ) : null}
        <tbody
          data-cy="study-list-results"
          data-querying={querying}
        >
          {tableDataSource.map((tableData, i) => (
            <StudyListTableRow
              tableData={tableData}
              key={i}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

StudyListTable.propTypes = {
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      expandedContent: PropTypes.node.isRequired,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func.isRequired,
      isExpanded: PropTypes.bool.isRequired,
    })
  ),
  querying: PropTypes.bool,
  filtersMeta: PropTypes.array,
  filterValues: PropTypes.object,
  onFilterChange: PropTypes.func,
  isSortingEnabled: PropTypes.bool,
};

export default StudyListTable;
